module.exports = __webpack_public_path__ + "static/media/icon-pdf.1d7c3a9b.svg";